import { Injectable, ElementRef, EventEmitter, Output, Injector } from '@angular/core';
import { GeoCoder } from 'geo-coder';
import { Configuration } from '../../configurations/shared.config';
import { Map, View, layer, source, Feature, proj, interaction, format, style, control, Collection } from 'openlayers';
import { DiagnosedItem } from '../../dataModels/diagnosed-item';

declare var $: any;

@Injectable()
export class MapService2 extends DiagnosedItem {
    private map: Map;
    private View: View;
    zoom: number;
    mapType: string;
    centerX: number;
    centerY: number;
    mapUrl: string;
    minZoom: number;
    maxZoom: number;
    private drawingGraphicsLayer: layer.Vector;
    private geofencesGraphicsLayer: layer.Vector;
    private drawingGraphicSource: source.Vector = new source.Vector({});
    geofencesGraphicSource: source.Vector = new source.Vector({});
    private wktFormat: format.WKT = new format.WKT();
    private googleMapUrl: string = 'http://mt1.google.com/vt/lyrs=m&x={x}&y={y}&z={z}';
    private esriMapUrl: string = 'https://server.arcgisonline.com/arcgis/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}';
    @Output() revGeocodingResult: EventEmitter<any> = new EventEmitter();
    @Output() geocodingResult: EventEmitter<any> = new EventEmitter();
    @Output() modifyFeatureEndEvent: EventEmitter<any> = new EventEmitter();
    currentMapSize: number[] = [];
    selectControl: any;
    modifyControl: any;
    selectedFeaturesForEdit: any = new Collection();

    constructor(protected injector: Injector) {
        super(injector);
    }
    public setMapSettings(_centerLong, _centerLat, _zoom, _containerId: string, _baseMapType, geocoding: boolean, MapUrl: string, minZoom: number, maxZoom: number) {
        this.drawingGraphicsLayer = new layer.Vector({ source: this.drawingGraphicSource });
        this.geofencesGraphicsLayer = new layer.Vector({ source: this.geofencesGraphicSource });

        this.checkMapParameters(_centerLong, _centerLat, _zoom, _baseMapType, MapUrl, minZoom, maxZoom);
        var self = this;
        var baseMapLayer;
        // switch (_baseMapType) {
        if (this.mapType.toLowerCase() == "osm" || !this.mapUrl) {
            baseMapLayer = new source.OSM();
        }
        else {
            baseMapLayer = new source.XYZ({ url: this.mapUrl });
        }
        this.map = new Map({
            controls: control.defaults({
                attributionOptions: ({
                    collapsible: false
                })
            }),
            view: new View({
                center: proj.fromLonLat([this.centerX, this.centerY], 'EPSG:3857'),
                zoom: this.zoom,
                minZoom: this.minZoom,
                maxZoom: this.maxZoom
            }),
            layers: [
                new layer.Tile({
                    source: baseMapLayer
                }), this.drawingGraphicsLayer,
                this.geofencesGraphicsLayer
            ],
            target: _containerId
        });
        this.map.updateSize();
        if (geocoding) {
            this.addGeocodingControl();
        }
        var elem = $("#topnav").find('a').eq(0);
        if (elem) {
            elem.click(function () {
                setTimeout(function () { self.map.updateSize(); }, 200);
            });
        }

        this.addEditControl();
        //  baseMapLayer.changed();

    }
    public UpdateMapSize() {
        if (this.map)
            this.map.updateSize();
    }
    public getMapObject() {
        return this.map;
    }
    public zoomToFeature(_feature: Feature) {
        var extent = _feature.getGeometry().getExtent();
        var size: any = this.map.getSize();
        this.map.getView().fit(extent, size);

    }
    public getGraphicSource(type) {
        if (type == 'draw') {
            return this.drawingGraphicSource;
        }
        else {
            return this.geofencesGraphicSource;
        }
    }
    public addInteraction(_interaction: any) {
        this.map.addInteraction(_interaction);
    }
    public removeInteraction(_interaction: any) {
        this.map.removeInteraction(_interaction);
    }
    public addFeatureOnMap(featureId, geometryString, source, isFeature = false, addToMap = true) {
        var geofenceFeature;
        if (!isFeature) {
            geofenceFeature = this.wktFormat.readFeature(geometryString);
            var geometry = geofenceFeature.getGeometry().transform("EPSG:4326", "EPSG:3857");
            geofenceFeature.setGeometry(geometry);
            geofenceFeature.setId(featureId);
        }
        else
            geofenceFeature = geometryString;
        if (addToMap) {
            source.addFeature(geofenceFeature);
            source.refresh();
        }
        return geofenceFeature;
    }
    public createGraphicLayer() {
        var graphicSource = new source.Vector({});
        var graphicLayer = new layer.Vector({ source: graphicSource });
        this.map.addLayer(graphicLayer);
    }
    public UpdategraphicLayerSource(layer, features, isEsriFormat: boolean) {
        var formattedFeatures = features;
        var source = new source.Vector({});
        layer.setSource(source);
        if (isEsriFormat)
            formattedFeatures = this.formatEsriJson(features);
        source.addFeatures(formattedFeatures);
        source.refresh();
    }
    public formatEsriJson(features) {
        var esrijsonFormat = new format.EsriJSON();
        var formattedFeaturs = [];
        for (var feat of features) {
            var feature = esrijsonFormat.readFeature(feat, { dataProjection: 'EPSG:4326', featureProjection: 'EPSG:3857' });
            feature.setStyle(new style.Style({
                stroke: new style.Stroke({
                    color: this.getRandomColor(),
                    width: 2.5
                })
            }));
            formattedFeaturs.push(feat);
        }
        return formattedFeaturs;
    }
    getRandomColor() {
        var letters = '0123456789ABCDEF';
        var color = '#';
        for (var i = 0; i < 6; i++) {
            color += letters[Math.floor(Math.random() * 16)];
        }
        return color;
    }
    public addGeocodingControl() {
        var geoCoder = new GeoCoder({
            provider: 'osm'  // 'osm', or 'bing' or google
        });
        var xthis = this;
        this.map.on("click", function (e) {
            var coords = e.coordinate;
            coords = proj.transform(coords, 'EPSG:3857', 'EPSG:4326');
            // lat , lng
            geoCoder.reverse(coords[1], coords[0]).then(result => {
                var addressResult = { 'lat': result.raw.lat, 'lng': result.raw.lon, 'address': result.address };
                if (xthis.drawingGraphicSource.getFeatures().length > 0)
                    xthis.deleteFeature(1, xthis.drawingGraphicSource);
                var feature = xthis.addFeatureOnMap(1, 'POINT(' + addressResult.lng + ' ' + addressResult.lat + ')', xthis.drawingGraphicSource);
                xthis.map.getView().setCenter(feature.getGeometry().getLastCoordinate());
                xthis.map.getView().setZoom(18);
                // console.log('result', addressResult);
                xthis.revGeocodingResult.emit(addressResult);
            });
        });

        let inputEl = document.querySelector('#address');
        geoCoder.autocomplete(inputEl);
        inputEl.addEventListener('place_changed', (event: any) => {
            let address = event.target.value;
            geoCoder.geocode(address).then(result => {
                var addressResult = { 'lat': result[0].lat, 'lng': result[0].lon, 'address': result[0].formatted };
                if (this.drawingGraphicSource.getFeatures().length > 0)
                    this.deleteFeature(1, this.drawingGraphicSource);
                var feature = this.addFeatureOnMap(1, 'POINT(' + addressResult.lng + ' ' + addressResult.lat + ')', this.drawingGraphicSource);
                this.map.getView().setCenter(feature.getGeometry().getLastCoordinate());
                this.map.getView().setZoom(18);
                console.log('autocomplete result', addressResult);
                this.geocodingResult.emit(addressResult);
            });
        });
    }
    public deleteFeature(featureId, source) {
        var feature = source.getFeatureById(featureId);
        if (feature) {
            source.removeFeature(feature);
            source.refresh();
        }
    }
    public enableEditControl(enable: boolean, feature = null) {
        if (feature != null) {
            this.selectedFeaturesForEdit.clear();
            this.selectedFeaturesForEdit.push(feature);
        }

        this.modifyControl.setActive(enable);
        //this.selectControl.setActive(enable);
        if (!enable) {
            this.removeInteraction(this.modifyControl);
            this.removeInteraction(this.selectControl);
        }
        else {
            this.addInteraction(this.modifyControl);
            this.addInteraction(this.selectControl);
        }
    }

    private addEditControl() {
        var options: any = {
            features: this.selectedFeaturesForEdit,
            source: this.geofencesGraphicSource,
            style: new style.Style({
                stroke: new style.Stroke(({
                    color: "red",
                    width: 1.50
                }))
            })
        };
        this.selectControl = new interaction.Select(options);
        this.selectControl.setActive(false);

        this.modifyControl = new interaction.Modify({
            features: this.selectedFeaturesForEdit
        });
        this.modifyControl.setActive(false);
        var self = this;
        this.modifyControl.on("modifyend", function (e) {
            self.modifyFeatureEndEvent.emit(e.features.item(0));
        });
    }
    public featureToWKT(feature) {
        // transform from web mercator to long and lat cords 
        //  var geomTransformed = feature.getGeometry().transform("EPSG:3857", "EPSG:4326");
        // feature.setGeometry(geomTransformed);
        return this.wktFormat.writeFeature(feature, { dataProjection: "EPSG:4326", featureProjection: "EPSG:3857" });
    }
    // Check and validate map paramaters
    private checkMapParameters(centerLong, centerLat, zoom, baseMapType, mapUrl, minZoom, maxZoom): void {
        this.centerX = centerLong ? centerLong : Configuration.defaultMapParams.centerX;
        this.centerY = centerLat ? centerLat : Configuration.defaultMapParams.centerY;
        this.mapType = baseMapType ? baseMapType : Configuration.defaultMapParams.mapType;
        this.zoom = zoom ? zoom : Configuration.defaultMapParams.zoom;
        this.minZoom = minZoom ? minZoom : Configuration.defaultMapParams.minZoom;
        this.maxZoom = maxZoom ? maxZoom : Configuration.defaultMapParams.maxZoom;
        if (this.mapType.toLowerCase() != 'osm') {
            if (!mapUrl) {
                if (this.mapType == 'google')
                    this.mapUrl = Configuration.urls.GoogleMapUrl;
                else if (this.mapType == 'esri')
                    this.mapUrl = Configuration.urls.ESRIMapUrl;
            }
            else
                this.mapUrl = mapUrl;
        }
        else
            this.mapUrl = null;
    }

    ngOnAfterViewInit() {
        this.map.updateSize();
    }
}



// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/services/maps/map2.service.ts